<div fxFill fxLayout="column" fxLayoutAlign="start center">
    <div fxFlex="70px" fxLayout="row" fxLayoutAlign="space-between" style="width: 100%">
        <div fxFlex>
            <h3>{{ data.title }}</h3>
        </div>
        <div fxFlex="40px">
            <button mat-icon-button (click)="close()">
                <mat-icon color="primary"> close </mat-icon>
            </button>
        </div>
    </div>
    <div fxFlex fxLayout="column" fxLayoutAlign="space-around" fxLayoutGap="10px" style="width: 100%">
        <mat-card
            *ngIf="data.courseId"
            (click)="close()"
            [routerLink]="['/new-payment', data.courseId]"
            [queryParams]="data.isCertificate ? { certificate: true } : null"
            class="green-button"
        >
            <mat-card-title>{{ "PRICING.SINGLE_PURCHASE" | translate }}</mat-card-title>
            <mat-card-subtitle style="color: white; font-weight: bold">
                {{ data.fixedPrice | currency: "BRL" }}
            </mat-card-subtitle>
        </mat-card>
        <h3 *ngIf="(plans$ | async)?.length > 0">{{ "PRICING.PLANS" | translate }}</h3>
        <mat-card
            *ngFor="let plan of plans$ | async"
            (click)="close()"
            [routerLink]="['/new-payment', plan.id, 'plans']"
            class="green-button"
        >
            <mat-card-title>{{ plan.name }}</mat-card-title>
            <mat-card-content style="color: white">
                <app-plan-description [plan]="plan"></app-plan-description>
            </mat-card-content>
        </mat-card>
        <div fxFlex fxLayout="row" fxLayoutAlign="space-between" style="width: 100%" *ngIf="data.customMessage">
            <p [innerHTML]="data.customMessage | safeHTML"></p>
        </div>
    </div>
</div>
